const languages = [
  { label: "Hindi", value: "hi" }, // Hindi
  { label: "English", value: "en" }, // English (US)
  { label: "English UK", value: "en-uk" }, // English (UK)
  { label: "Spanish", value: "es" }, // Spanish
  { label: "French", value: "fr" }, // French
  { label: "Japanese", value: "ja" }, // Japanese
  { label: "Czech", value: "cs" }, // Czech
  { label: "Dutch", value: "nl" }, // Dutch
  { label: "Slovak", value: "sk" }, // Slovak
  { label: "Russian", value: "ru" }, // Russian
  { label: "German", value: "de" }, // German
  { label: "Italian", value: "it" }, // Italian
  { label: "Korean", value: "ko" }, // Korean
  { label: "Brazilian Portuguese", value: "pt-BR" }, // Brazilian Portuguese
  { label: "Arabic", value: "ar" }, // Arabic
  { label: "Turkish", value: "tr" }, // Turkish
];

export default languages;
